import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { usePreferences } from '../hooks/use-preferences';

export { toast } from 'sonner';

/** App-wide toast host (DESIGN.md T8): bottom-right, max 3 visible, follows the theme. */
export function Toaster(props: ToasterProps) {
  const { theme } = usePreferences();
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      visibleToasts={3}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: 'bg-popover text-popover-foreground border-border shadow-md',
          description: 'text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
